(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerSection = document.querySelector('.header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      let lastWidth = window.innerWidth;
      let lastHeight = window.innerHeight;

      this.setHeaderHeight();
      if (this.headerSection.dataset.stickyType == 'disable') return;
      this.headerSection.dataset.stickyType == 'on_scroll' ? this.onScrollHandler = this.onScroll.bind(this) : this.onScrollHandler = this.onAlwaysScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      document.addEventListener('shopify:section:load', (event) => {
        if(event.target.closest('.shopify-section-header') ||  event.target.closest('.shopify-section-announcement-bar')) {
            this.setHeaderHeight()
            this.onScrollHandler()
        }
      })

      this.createObserver();

      this.boundHandleScrollOnce = this.handleScrollOnce.bind(this);
      window.addEventListener('scroll', this.boundHandleScrollOnce, { passive: true });
      window.addEventListener('load', () => {
        requestAnimationFrame(() => {
            this.shopifySection = document.querySelector('.shopify-section-header')
            if(this.shopifySection.className.includes('overlap-enable') || (this.shopifySection.className.includes('overlap-desktop') && window.innerWidth > 1024) || (this.shopifySection.className.includes('overlap-mobile') && window.innerWidth < 1025)) {
                const scrollTopPage = window.scrollY || document.documentElement.scrollTop;
                if (scrollTopPage > 5) this.shopifySection.classList.add('animate');
            }
            window.removeEventListener('scroll', this.handleScrollOnce());
        });
      });
    }

    handleScrollOnce() {
        this.shopifySection = document.querySelector('.shopify-section-header')
        if(this.shopifySection.className.includes('overlap-enable') || (this.shopifySection.className.includes('overlap-desktop') && window.innerWidth > 1024) || (this.shopifySection.className.includes('overlap-mobile') && window.innerWidth < 1025)) {
            const scrollTopFirst = window.scrollY || document.documentElement.scrollTop;
            if (scrollTopFirst > 5) this.shopifySection.classList.add('animate');
        }

        window.removeEventListener('scroll', this.boundHandleScrollOnce);
    }

    setHeaderHeight() {
        if (this.header && this.header.previousElementSibling) this.headerGroup1 = this.header.previousElementSibling
        if (this.headerGroup1 && this.headerGroup1.previousElementSibling) this.headerGroup2 = this.headerGroup1.previousElementSibling
        if (this.headerGroup2 && this.headerGroup2.previousElementSibling) this.headerGroup3 = this.headerGroup2.previousElementSibling
        this.headerGroupHeight = this.header.querySelector('.header').offsetHeight
        if (this.headerGroup1) this.headerGroupHeight = this.headerGroupHeight + this.headerGroup1.offsetHeight
        if (this.headerGroup2) this.headerGroupHeight = this.headerGroupHeight + this.headerGroup2.offsetHeight
        if (this.headerGroup3) this.headerGroupHeight = this.headerGroupHeight + this.headerGroup3.offsetHeight
        document.documentElement.style.setProperty('--header-height', `${this.headerGroupHeight}px`)
    }

    disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.headerSection);
    }

    onScroll() { 
      if (document.body.classList.contains('disable-scroll') || document.body.classList.contains('disable-scroll-body')) return
      if (document.body.classList.contains('after-focusout')) return
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerRect = this.headerSection.getBoundingClientRect();
      let headerBottom = headerRect.bottom;
      if (scrollTop <= 0) {
        this.reset();
        return;
      }
      if(this.querySelector('details-dropdown[open]')) {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        if (scrollTop <= this.headerBounds.top) this.header.classList.remove('shopify-section-header-sticky', 'animate');
        return
      }
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop + 3 && scrollTop > this.headerGroupHeight) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    onAlwaysScroll() { 
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 5) this.header.classList.add('animate')
      if (scrollTop < 5 && !document.body.classList.contains('disable-scroll') && !document.body.classList.contains('disable-scroll-body') && !document.body.classList.contains('after-focusout')) {
        this.header.classList.remove('animate')
      }
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class SearchElement extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
        if(!this.querySelector('.search-field__text')) return
        this.querySelector('.search-field__text').addEventListener('focus', () => {
            const scrollY = window.scrollY || window.pageYOffset;
            document.body.dataset.scrollY = scrollY;
            document.body.style.top = `-${scrollY}px`;
            document.body.classList.add('disable-scroll-body')
        })
        this.querySelector('.search-field__text').addEventListener('focusout', () => {
            this.querySelector('.search-field__text').value = ''
            if (document.body.classList.contains('disable-scroll-body')) {
                document.body.classList.add('after-focusout')
                document.documentElement.style.scrollBehavior = 'auto'
                const scrollY = parseInt(document.body.dataset.scrollY || '0', 10);
                document.body.classList.remove('disable-scroll-body')
                document.body.style.top = '';
                window.scrollTo({ top: scrollY, left: 0, behavior: 'auto' });
            }
            setTimeout(() => {document.documentElement.style.scrollBehavior = 'smooth'},10)
            setTimeout(() => document.body.classList.remove('after-focusout'), 200)
        })
    }

  }
  customElements.define('search-element', SearchElement);

  } catch(e) { console.error(e); }
})();
})();
